import { isValidEmailAddress, fadeOutNotifications } from '../functions';

$(document).ready(function() {
	$(document).on('click', '#return_to_other_location', function(e) {
		if ($('#return_to_other_location').is(':checked')) {
			$('.return-location-cointainer').show();
			$('.return-to-other-location-cointainer').hide();
		} else {
			$('.return-to-other-location-cointainer').show();
			$('.return-location-cointainer').hide();
		}
	});

	const searchWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.check-availability-btn', this, this.checkAvailability);
        },
		checkAvailability(event) {
			const _this = event.data;
			let url = $(this).data('url');
			if (!url || url == '' || url == null) {
				console.error('Invalid URL!');
				return false;
			}

			if ($('#pickup_location option:selected').val() == '') {
				alert('Select pickup location!');
				return;
			}
			if ($('#return_to_other_location').is(':checked')) {
				if ($('#return_location option:selected').val() == '') {
					alert('Select return location!');
					return;
				}
			}
			if ($('#pickup_date').val() == '') {
				alert('Select pickup date!');
				return;
			}
			if ($('#return_date').val() == '') {
				alert('Select pickup date!');
				return;
			}

			let genUrl = '?pl=' + $('#pickup_location option:selected').val();
			if ($('#return_to_other_location').is(':checked')) {
				genUrl += '&rol=1';
				genUrl += '&rl=' + $('#return_location option:selected').val();
			}
			genUrl += '&pd=' + $('#pickup_date').val() + '-' + $('#pickup_time option:selected').val();
			genUrl += '&rd=' + $('#return_date').val() + '-' + $('#return_time option:selected').val();
			if ($('#age-25-70').is(':checked')) {
				genUrl += '&age=1';
			}
			if ($('#travel-abroad').is(':checked')) {
				genUrl += '&ta=1';
			}
			if ($('#pet-friendly').is(':checked')) {
				genUrl += '&pf=1';
			}

			window.location = url + genUrl;
		}
    };

    if ($('.search-widget').length) {
        searchWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search-widget.js